import { wait } from './machine/helpers';
import { GameState, gameStates } from './machine/state-types';

export const state: GameState = {
    name: gameStates.wheelOfFortuneDouble,
    onEnter: async setState => {
        await wait(500);
        setState(gameStates.wheelOfFortune);
    },
    onExit: () => {}
};
